import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

function TestimonialBox({ img, number, paragraphs }) {
  const { t } = useTranslation()
  const textsRange = [...Array(paragraphs + 1).keys()].slice(1)

  return (
    <div className="testimonial-box">
      <div className="testimonial-box__top-icon">
        <img className="top-icon" src={img} alt="Testimonial" />
      </div>
      <div className="testimonial-box__wrapper">
        <div className="testimonial-box__shape">
          <div className="testimonial-box__text-container">
            <div className="testimonial-box__text">
              {textsRange.map((value) => (
                <div key={`testimonial-box-${value}`}>
                  {t(`landing.testimonials.box_${number}.text_${value}`)}
                </div>
              ))}
            </div>
            <ul className="testimonial-box__subtext">
              <li>
                {t(`landing.testimonials.box_${number}.subtext_1`)}
                <br />
                {t(`landing.testimonials.box_${number}.subtext_2`)}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

TestimonialBox.propTypes = {
  img: PropTypes.string.isRequired,
  number: PropTypes.number,
  paragraphs: PropTypes.number
}

TestimonialBox.defaultProps = {
  number: 1,
  paragraphs: 1
}

export default TestimonialBox
